
export function removeEmptyValues(obj: Record<string, any>): Record<string, any>{
  const newObj: Record<string, any> = {};
  for (const key in obj) {
      const value = obj[key];
      if (value !== null && value !== undefined ) {
          newObj[key] = value
      }
  }
  return newObj
}